var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledFailureCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34433",
    "data-name": "Group 34433",
    transform: "translate(-1651 -333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1131",
    "data-name": "Ellipse 1131",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(1651 333)",
    fill: "#b8bbbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34435",
    "data-name": "Group 34435",
    transform: "translate(-0.091 -0.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73117",
    "data-name": "Path 73117",
    d: "M4290.589-6634.061l9.182-9.217",
    transform: "translate(-2632.09 6983.777)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73118",
    "data-name": "Path 73118",
    d: "M4299.771-6634.061l-9.182-9.217",
    transform: "translate(-2632.09 6983.777)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledFailureCheck);
export default __webpack_public_path__ + "static/media/disabled-failure-check.7272cb9888b72f5d641d18d1942ed393.svg";
export { ForwardRef as ReactComponent };